import { Spinner } from "components/ui/spinner";

function LoadingSpinner() {
    return (
        <div className="flex justify-center p-2" role="status">
            <Spinner />
            <span className="sr-only">Loading...</span>
        </div>
    );
}

export default LoadingSpinner;
